let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("4shhd"), load("eEyVs"), load("hhss7"), load("i8Yee")]).then(() => parcelRequire('de33F'));